import React from 'react'
import { Oval } from 'react-loader-spinner'

function Loading() {
    return (
        <div className='w-full fixed z-[999999999] top-0 left-0 bg-white/70 flex items-center justify-center h-full'>
            <Oval color='#7565db' secondaryColor='#7565db' width={40} strokeWidth={4} height={40} />
        </div>
    )
}

export default Loading